import { ArrayHelper } from "./Helpers/ArrayHelper";
import { ObjectHelper } from "./Helpers/ObjectHelper";
import { NAMESPACE } from "./_Namespace";

type ObjectVisitorData = { obj: any, keys: string[], keyIndex: number, newObject: any };

export abstract class ObjectVisitor
{
    public static classNamespace = NAMESPACE + "ObjectVisitor";
    public static className = "ObjectVisitor";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    // #region Public Methods

    public async visitAsync<T>(obj: any): Promise<T | undefined>
    {
        let
            newObj = this.getNewObject(obj);

        if (!newObj)
            return;

        const
            initialData: ObjectVisitorData = { obj, keys: Object.keys(obj), keyIndex: -1, newObject: newObj },
            stack: ObjectVisitorData[] = [initialData];

        while (stack.length)
        {
            const
                stackLengthOriginal = stack.length,
                stackObject = stack[stack.length - 1];

            while (stackObject.keyIndex < stackObject.keys.length - 1)
            {
                stackObject.keyIndex++;

                const
                    nextObj: any = stackObject.obj[stackObject.keys[stackObject.keyIndex]];

                newObj = this.getNewObject(nextObj)

                if (newObj)
                {
                    stack.push({ obj: nextObj, keys: Object.keys(nextObj), keyIndex: -1, newObject: stackObject.newObject[stackObject.keys[stackObject.keyIndex]] = this.getNewObject(nextObj) });
                    break;
                }

                stackObject.newObject[stackObject.keys[stackObject.keyIndex]] = nextObj;
            }

            if (stackLengthOriginal != stack.length)
                continue;

            const
                completedObject = stack.pop();

            if (completedObject)
            {
                completedObject.newObject = await this.objectVisitedAsync(completedObject.newObject);

                if (stack.length)
                {
                    const
                        stackObjectToUpdate = stack[stack.length - 1];

                    stackObjectToUpdate.newObject[stackObjectToUpdate.keys[stackObjectToUpdate.keyIndex]] = completedObject.newObject;
                }
                else
                    initialData.newObject = completedObject.newObject;
            }
        }

        return initialData.newObject as T;
    }

    // #endregion

    // #region Protected Methods

    protected abstract objectVisitedAsync(obj: any): Promise<any>;

    // #endregion

    // #region Private Methods

    private getNewObject(obj: any): object | any[] | undefined
    {
        if (ObjectHelper.isPlainObject(obj))
            return {};

        if (ArrayHelper.isArrayLike(obj))
            return [];
    }

    // #endregion
}